class Panel extends HTMLElement {
  constructor() {
    super();

    this.isOpen = this.getAttribute('default-open') === 'true';
    this.alignment = this.getAttribute('alignment') || 'right';
    this.additionalClasses = this.getAttribute('additionalClasses') || '';
    this.context = this.getAttribute('context');

    this.updatePanelClass();

    this.handleOpenEvent = this.handleOpenEvent.bind(this);
    this.handleCloseEvent = this.handleCloseEvent.bind(this);
    this.handleToggleEvent = this.handleToggleEvent.bind(this);
  }

  connectedCallback() {
    this.triggers = {
      openTriggerEl: document.querySelector(this.getAttribute('openTriggerSelector')),
      closeTriggerEl: document.querySelector(this.getAttribute('closeTriggerSelector')),
      toggleEl: document.querySelector(this.getAttribute('toggleSelector')),
    };

    const { openTriggerEl, closeTriggerEl, toggleEl } = this.triggers;

    if (openTriggerEl) openTriggerEl.addEventListener('click', this.handleOpenEvent);
    if (closeTriggerEl) closeTriggerEl.addEventListener('click', this.handleCloseEvent);
    if (toggleEl) toggleEl.addEventListener('click', this.handleToggleEvent);

    if (this.context) {
      document.addEventListener(`${this.context}:open`, this.handleOpenEvent);
      document.addEventListener(`${this.context}:close`, this.handleCloseEvent);
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'default-open') {
      this.isOpen = newValue === 'true';
      this.updatePanelClass();
    }
  }

  disconnectedCallback() {
    const { openTriggerEl, closeTriggerEl, toggleEl } = this.triggers;

    if (openTriggerEl) openTriggerEl.removeEventListener('click', this.handleOpenEvent);
    if (closeTriggerEl) closeTriggerEl.removeEventListener('click', this.handleCloseEvent);
    if (toggleEl) toggleEl.removeEventListener('click', this.handleToggleEvent);

    if (this.context) {
      document.removeEventListener(`${this.context}:open`, this.handleOpenEvent);
      document.removeEventListener(`${this.context}:close`, this.handleCloseEvent);
    }
  }

  handleOpenEvent(e) {
    e.preventDefault();
    e.stopPropagation();
    this.isOpen = true;
    this.updatePanelClass();
  }

  handleCloseEvent(e) {
    e.preventDefault();
    e.stopPropagation();
    this.isOpen = false;
    this.updatePanelClass();
  }

  handleToggleEvent(e) {
    e.preventDefault();
    e.stopPropagation();
    this.isOpen = !this.isOpen;
    this.updatePanelClass();
  }

  static get observedAttributes() {
    return ['default-open'];
  }

  updatePanelClass() {
    const closedClass = this.alignment === 'right' ? 'translate-x-full' : '-translate-x-full';
    this.className = `
      block
      max-w-panel
      w-full h-full
      fixed
      top-0
      bottom-0
      transition-transform
      z-40
      bg-white
      ${this.alignment === 'right' ? 'right-0' : 'left-0'} ${this.isOpen ? 'translate-x-0' : closedClass
      } ${this.additionalClasses}`;
  }
}

if (!customElements.get('slide-panel')) {
  customElements.define('slide-panel', Panel);
}
